import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.ends-with";
import "core-js/modules/es.string.split";
import moment from 'moment';
import { oddNumbersFormatter, formatNumber, formatPrice } from '@utils/format-number';
import MoneylineIcon from '!!url-loader?!@static/icons/s-moneyline.svg';
import TotalIcon from '!!url-loader?!@static/icons/s-total.svg';
import SpreadIcon from '!!url-loader?!@static/icons/s-spread.svg';
/**
 *
 * @param {Number} bytes
 */

export function humanReadableByteCount(bytes) {
  return bytes < 1000 ? bytes + ' B' : bytes < 999950 ? "".concat(Math.round(bytes / 100) / 10, "kB") : (bytes /= 1000) < 999950 ? "".concat(Math.round(bytes / 100) / 10, "MB") : (bytes /= 1000) < 999950 ? "".concat(Math.round(bytes / 100) / 10, "GB") : (bytes /= 1000) < 999950 ? "".concat(Math.round(bytes / 100) / 10, "TB") : (bytes /= 1000) < 999950 ? "".concat(Math.round(bytes / 100) / 10, "PB") : "".concat(Math.round(bytes / 100000) / 10, "EB");
}
export function riskToWin(riskUnits, odd) {
  if (riskUnits === null || riskUnits === undefined) return riskUnits;
  if (odd === 0) return 0;
  if (odd < 0) return Math.round(-1 * riskUnits * 100 / odd * 100) / 100;
  return Math.round(riskUnits * odd / 100 * 100) / 100; // if (odd < 0) return Math.floor(((-1 * riskUnits * 100) / odd) * 100) / 100;
  // return Math.floor(((riskUnits * odd) / 100) * 100) / 100;
}
export function winToRisk(winUnits, odd) {
  var isRound = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (winUnits === null || winUnits === undefined) return winUnits;
  if (odd === 0) return 0;
  if (odd < 0) return isRound ? Math.round(-1 * winUnits * odd / 100 * 100) / 100 : -1 * winUnits * odd / 100 * 100 / 100;
  return isRound ? Math.round(winUnits * 100 / odd * 100) / 100 : winUnits * 100 / odd * 100 / 100; // if (odd < 0) return Math.ceil(((-1 * winUnits * odd) / 100) * 100) / 100;
  // return Math.ceil(((winUnits * 100) / odd) * 100) / 100;
}
/**
 *
 * @param {Date} date
 */

export function formatDateShort(date) {
  return moment(date).calendar(null, {
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: 'MMM DD',
    lastDay: 'MMM DD',
    lastWeek: 'MMM DD',
    sameElse: 'MMM DD'
  });
}
/**
 *
 * @param {Date} date
 */

export function formatTime(date) {
  return moment(date).format('hh:mm A');
}
/**
 *
 * @returns {{oddLabel?: string, oddValue: number}}
 */

export function getOddNums(odd, wagerType, selection, literals) {
  var oddPoints = undefined;
  var oddValue = undefined;
  var oddLabel = undefined;
  var oddTypeLabel = getOddTypeLabel(odd.oddType, wagerType, false, literals);

  if (wagerType === 'spread') {
    if (selection === 'home') {
      oddPoints = odd.pointSpreadHome;
      oddLabel = oddPoints === 0 ? 'PK' : oddNumbersFormatter(oddPoints);
      oddValue = odd.pointSpreadHomeLine;
    } else if (selection === 'away') {
      oddPoints = odd.pointSpreadAway;
      oddLabel = oddPoints === 0 ? 'PK' : oddNumbersFormatter(oddPoints);
      oddValue = odd.pointSpreadAwayLine;
    } else throw new Error("Invalid wagerType/selection combination: ".concat(wagerType, "/").concat(selection));
  } else if (wagerType === 'moneyLine') {
    if (selection === 'home') {
      oddValue = odd.moneyLineHome;
    } else if (selection === 'away') {
      oddValue = odd.moneyLineAway;
    } else if (selection === 'draw') {
      oddValue = odd.drawLine;
    } else throw new Error("Invalid wagerType/selection combination: ".concat(wagerType, "/").concat(selection));
  } else if (wagerType === 'total') {
    oddPoints = odd.totalNumber;

    if (selection === 'overLine') {
      oddLabel = "O ".concat(oddPoints);
      oddValue = odd.overLine;
    } else if (selection === 'underLine') {
      oddLabel = "U ".concat(oddPoints);
      oddValue = odd.underLine;
    } else throw new Error("Invalid wagerType/selection combination: ".concat(wagerType, "/").concat(selection));
  } else throw new Error("Invalid wagerType/selection combination: ".concat(wagerType, "/").concat(selection));

  return {
    oddLabel: oddLabel,
    oddValue: oddValue,
    oddPoints: oddPoints,
    oddTypeLabel: oddTypeLabel
  };
}
var vsSportCodes = {
  soccer: 'home',
  mma: 'away',
  golf: 'golf',
  tennis: 'tennis'
};
/**
 *
 * @param {string} sportCode
 * @returns {'vs.'|'at'}
 */

export function getEventNameDelimiter(sportCode) {
  if (vsSportCodes[sportCode]) return 'vs.';
  return 'at';
}
/**
 *
 * @param {string} sportCode
 * @param {string} homeTeam
 * @param {string} awayTeam
 * @returns {string}
 */

export function getEventNameHtml(sportCode, homeTeam) {
  var awayTeam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var vs = vsSportCodes[sportCode];
  if (vs) return vs === 'home' ? "".concat(homeTeam ? "".concat(homeTeam, "<span> vs. </span>").concat(awayTeam) : awayTeam) : "".concat(awayTeam ? "".concat(awayTeam, "<span> vs. </span>").concat(homeTeam) : homeTeam);
  if (!awayTeam) return homeTeam;
  return "".concat(awayTeam, "<span> at </span>").concat(homeTeam);
}
/**
 *
 * @param {string} sportCode
 * @param {string} homeTeam
 * @param {string} awayTeam
 * @returns {string}
 */

export function getEventName(sportCode, homeTeam) {
  var awayTeam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var vs = vsSportCodes[sportCode];

  if (vs) {
    return vs === 'home' ? "".concat(homeTeam, " vs. ").concat(awayTeam) : "".concat(awayTeam, " vs. ").concat(homeTeam);
  }

  if (!awayTeam) return homeTeam;
  return "".concat(awayTeam, " at ").concat(homeTeam);
}
export function getWagerTypeName(wagerType) {
  return wagerType === 'total' ? 'Total' : wagerType === 'moneyLine' ? 'Moneyline' : 'Spread';
}
export function getPickPaymentTypeName(pickPaymentType) {
  return pickPaymentType === 'free' ? 'Free' : pickPaymentType === 'paid' ? 'Paid' : 'Guaranteed';
}
export function ordinalSuffix(i) {
  var j = i % 10,
      k = i % 100;

  if (j == 1 && k != 11) {
    return i + 'st';
  }

  if (j == 2 && k != 12) {
    return i + 'nd';
  }

  if (j == 3 && k != 13) {
    return i + 'rd';
  }

  return i + 'th';
}
export function getSuggestedReason(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      userName = _ref.userName,
      reasonCode = _ref.reasonCode,
      params = _ref.params;
  var league = params['league'] ? " ".concat(params['league'], " ") : '';
  var wagerType = params['wagerType'] ? " ".concat(getWagerTypeName(params['wagerType']), " ") : '';
  var pickPaymentType = params['pickType'] ? " ".concat(getPickPaymentTypeName(params['pickType']), " ") : '';
  var picksKind = wagerType + league + pickPaymentType;
  if (reasonCode.endsWith('Rate')) return "".concat(formatNumber(Math.round(params['winRate']), {
    suffix: '%'
  }), " win percentage on ").concat(picksKind, " Picks");
  if (reasonCode.endsWith('Profit')) return "Profited ".concat(formatPrice(Math.floor(params['profit'])), " on ").concat(picksKind, " Picks");
  if (reasonCode === 'Leaderboard') return "Currently ranked ".concat(ordinalSuffix(params['position']), " on All-Time Leaderboard");
  if (reasonCode === 'Hotboard') return "Currently ranked ".concat(ordinalSuffix(params['position']), " on Hot Board");
  var friendlyName = firstName || lastName || "@".concat(userName);
  if (reasonCode === 'Job') return "".concat(friendlyName, " also works at ").concat(params['job']);
  if (reasonCode === 'Address') return "".concat(friendlyName, " also lives in ").concat(params['address']);
  if (reasonCode === 'University') return "".concat(friendlyName, " also attended ").concat(params['university']);
  return '';
}
export function getWagerTypeTitleAndIcon(wagerType, oddType, isShort, literals) {
  var title = oddType ? getOddTypeLabel(oddType, wagerType, isShort, literals) : '';

  switch (wagerType) {
    case 'spread':
      return {
        title: title,
        icon: SpreadIcon
      };

    case 'total':
      return {
        title: title,
        icon: TotalIcon
      };

    case 'moneyLine':
      return {
        title: title,
        icon: MoneylineIcon
      };

    default:
      throw new Error("Unknown wager type ".concat(wagerType));
  }
}
/**
 *
 * @param {string} oddType
 * @param {string} wagerType
 * @param {boolean} isShort
 * @returns {string}
 */

export function getOddTypeLabel(oddType, wagerType, isShort, literals) {
  function getShortLabel(str) {
    var parts = str.split(' ');

    if (parts.length > 1) {
      var firstPart = parts[0][0];
      var secondPart = parts[parts.length - 1] === 'Innings' ? 'F' : parts[parts.length - 1][0];
      return "".concat(firstPart).concat(secondPart);
    } else {
      return str;
    }
  }

  var odd = literals[oddType] || oddType;
  var oddPart = isShort ? getShortLabel(odd) : odd;
  var wagerPart = firstCapitalize(wagerType);
  return oddPart ? "".concat(oddPart, " ").concat(wagerPart) : wagerPart;
}
/**
 *
 * @param {string} str
 * @returns {string}
 */

export function firstCapitalize(str) {
  str = str.toLowerCase();
  return "".concat(str.charAt(0).toUpperCase()).concat(str.slice(1));
}